// Section 12 and 19: Plague (event only). 3 seasons untreated, 2 treated; death 25% per
// season (10% when treated with medicine this season; halved without medicine by the healer);
// very contagious (2x, its contagion weight); healers catch it at 10% instead of 3%.
// Constants: config.illnesses.plague, config.jobs.healer.plagueCatch.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { noDeltas } from '../../core/content-helpers';
import { defineIllness } from '../../core/registry';

export function plague(config: Config) {
  const c = config.illnesses.plague;

  return defineIllness({
    id: 'plague',
    label: 'Plague',
    section: 'S12',
    source: 'event',
    weight: c.weight,
    untreatedSeasons: c.untreated,
    treatedSeasons: c.treated,
    deathChance: c.death,
    contagious: true,
    modifierTargets: ['illnessDeath', 'catchRisk'],
    modifiers(ctx, target) {
      if (target.kind === 'catchRisk' && target.illnessId === 'plague') {
        return [mod.set('illness:plague', config.jobs.healer.plagueCatch, 'plague')];
      }
      if (target.kind !== 'illnessDeath' || target.illnessId !== 'plague') return [];
      return ctx.state.currentReport?.care?.[target.personId] === 'medicine'
        ? [mod.set('illness:plague', c.deathTreated, 'treated')]
        : [];
    },
    onCatch: (ctx, person) => [
      { kind: 'memory', personId: person.id, entry: { turn: ctx.season.turn, kind: 'fell-ill' } },
    ],
    onRecover: noDeltas,
  });
}
